import { namespace } from "@formant/core/common/config";

export function agentInstallScript(provisioningToken: string) {
    let url = "";
    switch (namespace) {
        case "local":
            url = "http://localhost:8080";
            break;
        default: {
            const extension = namespace === "prod" ? "" : `-${namespace}`;
            url = `https://app${extension}.formant.io`;
            break;
        }
    }

    const filterSideCarForNonProd =
        namespace !== "prod" ? ` | grep -v formant-sidecar` : "";
    return `bash <(wget -qO - ${url}/install-agent.sh${filterSideCarForNonProd}) ${provisioningToken}`;
}
